import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/my-healing-journey")({
  beforeLoad: () => {
    throw redirect({ to: "/how-to-start" });
  },
});
